if (!customElements.get('gc-cart-tier-message')) {
  customElements.define('gc-cart-tier-message', class extends HTMLElement {
    connectedCallback() {
      if (this.cartUpdated) return;
      this.cartUpdated = () => {
        const cart = this.closest('cart-items');
        if (!cart) return;
        const quantity = Array.from(cart.querySelectorAll('[data-items-holder] [data-quantity-field]'))
          .reduce((total, input) => total + (Number.parseInt(input.value, 10) || 0), 0);
        this.showTier(quantity);
      };
      document.addEventListener('theme:cart:added', this.cartUpdated);
      this.showTier(Number.parseInt(this.dataset.count, 10) || 0);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:cart:added', this.cartUpdated);
      this.cartUpdated = null;
    }

    showTier(quantity) {
      const tier = quantity >= 3 ? 'three' : quantity === 2 ? 'two' : 'one';
      const target = this.querySelector('[data-tier-content]');
      const template = this.querySelector(`template[data-tier="${tier}"]`);
      if (this.dataset.tier !== tier && target && template) {
        target.replaceChildren(template.content.cloneNode(true));
      }
      this.dataset.tier = tier;
      this.dataset.count = String(quantity);
      this.hidden = quantity === 0;
    }
  });
}
